var map = {
	"./Spoon-fork-knife-icon.png": "1350",
	"./atout.png": "6469",
	"./background/ImageBackground1.png": "b608",
	"./background/ImageBackground2.png": "d0d2",
	"./background/ImageBackground3.png": "bf85",
	"./background/back.png": "8ce7",
	"./background/pubag-back.png": "8083",
	"./bagsBa.png": "1726",
	"./bakery-bags-prime.png": "b883",
	"./bakery-bags.png": "fdac",
	"./chevron-down.png": "0fc3",
	"./dashboard.png": "a6231",
	"./digitable-menu.png": "0ad2",
	"./digitable-platforme-old.png": "c88f",
	"./digitable-platforme.png": "1226",
	"./exemple4.png": "54dd",
	"./features/banner.png": "2ccf",
	"./features/call.png": "8c0e",
	"./features/dashboard.png": "ed31",
	"./features/data.png": "109a",
	"./features/language.png": "22e9",
	"./features/menu.png": "7977",
	"./features/order.png": "ecfa",
	"./features/social.png": "77b2",
	"./header-logo.png": "62e7",
	"./logo-mini.png": "a2c8",
	"./logo-white.png": "06f1",
	"./logo.png": "9d64",
	"./mr-sushi/club.png": "f21d",
	"./mr-sushi/facebook.png": "68a6",
	"./mr-sushi/google-review.png": "cb3d",
	"./mr-sushi/instagram.png": "fe20",
	"./mr-sushi/menu.png": "1954",
	"./mr-sushi/tripadvisor.png": "01f2",
	"./pharma-bags-prime.png": "aa02",
	"./pharma-bags.png": "3312",
	"./pubag-logo.png": "6967",
	"./references/1.png": "c2ef",
	"./references/10.png": "81e7",
	"./references/11.png": "7aca",
	"./references/12.png": "c96f",
	"./references/13.png": "d93b",
	"./references/14.png": "714e",
	"./references/15.png": "ec35",
	"./references/16.png": "ddf1",
	"./references/17.png": "1993",
	"./references/18.png": "ed56",
	"./references/2.png": "3164",
	"./references/3.png": "287b",
	"./references/4.png": "3812",
	"./references/5.png": "c165",
	"./references/6.png": "6f9e",
	"./references/7.png": "e656",
	"./references/8.png": "20dd",
	"./references/9.png": "b6f7",
	"./sm-logo.png": "7c51",
	"./team-map-position.png": "a52a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";